import { 
    useRouteError,
    // link,
 } from "react-router-dom";
import rootDir from "..";

export default function ErrorPage() {
    const error: any = useRouteError();
    console.error(error);

    return (
        <div id="error-page">
            <h1>Oooops!</h1>
            <p>Sorry, an unexpected error has occured.</p>
            <p>
                <i>{error.statusText || error.message}</i>
            </p>
            <p>Try go back or check <a href={rootDir.toString()}>the front page</a>.</p>
        </div>
    );
}